import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "basic"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "width-wrap" }
const _hoisted_5 = { class: "page-content section" }
const _hoisted_6 = { class: "form-header" }
const _hoisted_7 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_8 = {
  key: 0,
  class: "flashmessage flash-success"
}
const _hoisted_9 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_10 = { class: "form-section has-aside" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { for: "frm-estateAgentProfileForm_firstName" }
const _hoisted_13 = {
  key: 0,
  class: "form-error"
}
const _hoisted_14 = { for: "frm-estateAgentProfileForm_lastName" }
const _hoisted_15 = {
  key: 0,
  class: "form-error"
}
const _hoisted_16 = { class: "form-field" }
const _hoisted_17 = { for: "frm-estateAgentProfileForm_email" }
const _hoisted_18 = {
  key: 0,
  class: "form-error"
}
const _hoisted_19 = { for: "frm-estateAgentProfileForm_phoneNumber" }
const _hoisted_20 = { class: "multiple-inputs" }
const _hoisted_21 = { class: "selectbox selectbox--phone-prefix" }
const _hoisted_22 = {
  key: 0,
  class: "form-error"
}
const _hoisted_23 = {
  key: 0,
  class: "form-error"
}
const _hoisted_24 = {
  key: 1,
  class: "form-error"
}
const _hoisted_25 = { for: "frm-estateAgentProfileForm_motto" }
const _hoisted_26 = {
  key: 0,
  class: "form-error"
}
const _hoisted_27 = { for: "frm-estateAgentProfileForm_description" }
const _hoisted_28 = {
  key: 0,
  class: "form-error"
}
const _hoisted_29 = { class: "form-field full-width" }
const _hoisted_30 = { for: "frm-estateAgentProfileForm_languages" }
const _hoisted_31 = { class: "checkbox checkbox--lang" }
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "form-section-aside"
}
const _hoisted_35 = { class: "form-upload-photo aspect-ratio aspect-ratio-1-1" }
const _hoisted_36 = { class: "aspect-ratio-body" }
const _hoisted_37 = {
  key: 0,
  class: "photo is-uploaded"
}
const _hoisted_38 = {
  key: 1,
  class: "upload-placeholder placeholder-user"
}
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = {
  key: 0,
  class: "form-error"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "form-footer" }
const _hoisted_43 = { class: "buttons" }
const _hoisted_44 = { class: "button button--primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhonePrefix = _resolveComponent("PhonePrefix")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Cropper = _resolveComponent("Cropper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("form", {
          id: "estateAgentProfile-form",
          class: "form",
          onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"])),
          autocomplete: "off"
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.form-header')), 1)
          ]),
          (_ctx.showFormMessages)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_ctx.isSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.success-message')), 1))
                  : _createCommentVNode("", true),
                (_ctx.isError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flashmessage flash-danger"
                  }, _toDisplayString(error), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.firstName.$error }])
              }, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.firstName')) + ":", 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "frm-estateAgentProfileForm_firstName",
                  name: "firstName",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.firstName.$model) = $event)),
                  class: "form-control is-required"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.v$.form.firstName.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.v$.form.firstName.$dirty && _ctx.v$.form.firstName.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.v$.form.firstName.required.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('forms.required')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.lastName.$error }])
              }, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.lastName')) + ":", 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "frm-estateAgentProfileForm_lastName",
                  name: "lastName",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.lastName.$model) = $event)),
                  class: "form-control is-required"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.v$.form.lastName.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.v$.form.lastName.$dirty && _ctx.v$.form.lastName.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.v$.form.lastName.required.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('forms.required')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.email')) + ":", 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  disabled: "",
                  id: "frm-estateAgentProfileForm_email",
                  name: "email",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                  class: "form-control is-required"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.v$.form.email.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.v$.form.email.$dirty && _ctx.v$.form.email.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.v$.form.email.required.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('forms.required')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.phoneNumber.$error }])
              }, [
                _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.phoneNumber')) + ":", 1),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_PhonePrefix, {
                      id: "frm-estateAgentProfileForm_phoneNumberPrefix",
                      modelValue: _ctx.v$.form.phoneNumberPrefix.$model,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.form.phoneNumberPrefix.$model) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.form.phoneNumber.$model) = $event)),
                    type: "text",
                    id: "frm-userProfileForm_phoneNumber",
                    placeholder: "900 000 000",
                    name: "phoneNumber",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.phoneNumber.$model,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                (_ctx.v$.form.phoneNumberPrefix.$dirty && _ctx.v$.form.phoneNumberPrefix.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.v$.form.phoneNumberPrefix.required.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('forms.required')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                ((_ctx.v$.form.phoneNumberPrefix.$dirty || _ctx.v$.form.phoneNumber.$dirty) && _ctx.v$.form.phoneNumber.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.v$.form.phoneNumber.required.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('forms.required')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.v$.form.phoneNumber.phoneNumber.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('forms.phone-number')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field full-width", { 'is-danger': _ctx.v$.form.motto.$error }])
              }, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.motto')) + ":", 1),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.form.motto.$model) = $event)),
                  type: "text",
                  id: "frm-estateAgentProfileForm_motto",
                  name: "motto",
                  class: "form-control",
                  rows: "3"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.v$.form.motto.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.v$.form.motto.$dirty && _ctx.v$.form.motto.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.v$.form.motto.required.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('forms.required')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field full-width", { 'is-danger': _ctx.v$.form.description.$error }])
              }, [
                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.description')) + ":", 1),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.form.description.$model) = $event)),
                  type: "text",
                  id: "frm-estateAgentProfileForm_description",
                  name: "description",
                  class: "form-control",
                  rows: "5"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.v$.form.description.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.v$.form.description.$dirty && _ctx.v$.form.description.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.v$.form.description.required.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('forms.required')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.languages')) + ":", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formModel.languages, (language) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: language.key
                  }, [
                    _createElementVNode("label", _hoisted_31, [
                      _createElementVNode("span", {
                        class: _normalizeClass('flag-lang-' + language.key)
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(language.value) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.languages) = $event)),
                        value: language.key
                      }, null, 8, _hoisted_32), [
                        [_vModelCheckbox, _ctx.form.languages]
                      ]),
                      _hoisted_33
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.estateAgentImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.estateAgentImage.isError }])
                  }, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        (_ctx.estateAgentImage.isSuccess)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              (_ctx.estateAgentImage.isSuccess)
                                ? (_openBlock(), _createBlock(_component_ResizableImage, {
                                    key: 0,
                                    url: _ctx.estateAgentImage.url,
                                    width: 220,
                                    height: 220,
                                    hrmode: "max",
                                    alt: _ctx.estateAgentImage.file,
                                    draggable: false
                                  }, null, 8, ["url", "alt"]))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", {
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteEstateAgentFile())),
                                class: "delete-photo"
                              }),
                              _createElementVNode("span", {
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editEstateAgentFile())),
                                class: "edit-photo"
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("label", _hoisted_38, [
                              _createElementVNode("input", {
                                type: "file",
                                accept: "image/jpeg",
                                ref: "estateAgentImage",
                                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleEstateAgentImageUpload()))
                              }, null, 544),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.photo-button')), 1),
                              _createElementVNode("i", {
                                innerHTML: _ctx.$t('EstateAgentProfileEdit.photo-button-info')
                              }, null, 8, _hoisted_39)
                            ])),
                        (_ctx.estateAgentImage.isUploading)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "progress-bar",
                              style: _normalizeStyle({ width: _ctx.estateAgentImage.uploadPercentage + '%' })
                            }, null, 4))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.estateAgentImage.isError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.estateAgentImage.text), 1))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_ctx.estateAgentImage.isSuccess)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                        _createTextVNode(_toDisplayString(_ctx.$t('EstateAgentProfileEdit.photo-edit1')) + " ", 1),
                        _createElementVNode("a", {
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editEstateAgentFile()))
                        }, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.photo-edit2')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("button", _hoisted_44, _toDisplayString(_ctx.$t('EstateAgentProfileEdit.button-save')), 1),
              _createVNode(_component_router_link, {
                to: { name: 'UserProfile' },
                tag: "button",
                class: "button button--primary reversed"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('EstateAgentProfileEdit.button-cancel')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ], 32)
      ])
    ]),
    (_ctx.showEstateAgentImageModal)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#container"
        }, [
          _createVNode(_component_Cropper, {
            img: _ctx.estateAgentImage.url,
            fileName: _ctx.estateAgentImage.file,
            aspectRatio: 1 / 1,
            accept: "image/jpeg",
            onUpload: _ctx.uploadEstateAgentImage,
            onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showEstateAgentImageModal = false))
          }, null, 8, ["img", "fileName", "onUpload"])
        ]))
      : _createCommentVNode("", true)
  ]))
}